import { render, staticRenderFns } from "./VcToast.vue?vue&type=template&id=796c89dc&scoped=true"
import script from "./VcToast.vue?vue&type=script&lang=js"
export * from "./VcToast.vue?vue&type=script&lang=js"
import style0 from "./VcToast.vue?vue&type=style&index=0&id=796c89dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796c89dc",
  null
  
)

export default component.exports